import React from 'react';
import AbsenceCategoryIcon from '../../../../components/AbsenceCategoryIcon';
import './AbsenceIcon.css';

type Props = {
  icon: string;
  color?: string | null;
  variant?: 'rounded' | 'plain';
  className?: string;
};

const AbsenceIcon: React.FC<React.PropsWithChildren<Props>> = ({
  icon,
  color,
  className,
  variant = 'rounded',
}) => {
  const categoryIcon = (
    <AbsenceCategoryIcon icon={icon} color={color} className={className} />
  );

  if (variant === 'plain') {
    return categoryIcon;
  }

  return <div className="absence-icon-container">{categoryIcon}</div>;
};

export default AbsenceIcon;
